// Module
var code = "<div class=\"terms-col\" ng-if=\"$ctrl.credits > 0\"> {{$ctrl.credits | singleDecimal }} {{::'CREDITS' | translate}} </div> <div class=\"terms-col\" ng-if=\"$ctrl.credits == 0\">-</div>";
// Exports
module.exports = code;